import { debugEvents, formatDebugDump, subscribeDebug } from './debug';

export function mountDebugPanel(root: HTMLElement) {
  const wrap = document.createElement('div');
  wrap.className = 'debug-root';
  wrap.innerHTML = `
    <button type="button" class="debug-toggle" id="debug-toggle" title="Open debug log">debug</button>
    <aside class="debug-drawer" id="debug-drawer" hidden>
      <header class="debug-head">
        <strong>Debug</strong>
        <span class="debug-sub">Copy this if a chart/module misbehaves. No API keys are included.</span>
        <div class="debug-actions">
          <button type="button" class="btn" id="debug-copy">Copy report</button>
          <button type="button" class="btn" id="debug-close">Close</button>
        </div>
      </header>
      <pre class="debug-log" id="debug-log"></pre>
    </aside>
  `;
  root.append(wrap);

  const drawer = wrap.querySelector('#debug-drawer') as HTMLElement;
  const logEl = wrap.querySelector('#debug-log') as HTMLElement;
  const toggle = wrap.querySelector('#debug-toggle') as HTMLButtonElement;

  function render() {
    logEl.textContent = debugEvents()
      .slice(-80)
      .map((e) => `${e.t.slice(11, 23)} ${e.level.padEnd(5)} [${e.src}] ${e.msg}${e.data != null ? ' ' + JSON.stringify(e.data) : ''}`)
      .join('\n');
    logEl.scrollTop = logEl.scrollHeight;
  }

  wrap.querySelector('#debug-toggle')!.addEventListener('click', () => {
    drawer.hidden = !drawer.hidden;
    toggle.classList.toggle('on', !drawer.hidden);
    if (!drawer.hidden) render();
  });
  wrap.querySelector('#debug-close')!.addEventListener('click', () => {
    drawer.hidden = true;
    toggle.classList.remove('on');
  });
  wrap.querySelector('#debug-copy')!.addEventListener('click', async () => {
    let server: unknown = null;
    try {
      const res = await fetch('/api/debug');
      server = await res.json();
    } catch (err) {
      server = { error: err instanceof Error ? err.message : String(err) };
    }
    const text = formatDebugDump({ server });
    try {
      await navigator.clipboard.writeText(text);
      (wrap.querySelector('#debug-copy') as HTMLButtonElement).textContent = 'Copied';
      setTimeout(() => {
        (wrap.querySelector('#debug-copy') as HTMLButtonElement).textContent = 'Copy report';
      }, 1500);
    } catch {
      window.prompt('Copy this debug dump', text);
    }
  });

  subscribeDebug(() => {
    if (!drawer.hidden) render();
  });
  render();
}
